import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-live-updates-features-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './live-updates-features-section.component.html',
  styleUrl: './live-updates-features-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveUpdatesFeaturesSectionComponent {}
